import React from 'react';
import { motion } from 'framer-motion';
import { Split, EyeOff, Users } from 'lucide-react';
const problems = [{
  icon: Split,
  title: 'Scattered Enclaves',
  description: 'Gothic and horror communities are fragmented across platforms built for mainstream content. Your voice drowns in algorithms that favor the ordinary.'
}, {
  icon: EyeOff,
  title: 'The Unseen Creator',
  description: 'Dark fantasy artists, writers, and musicians lack a dedicated marketplace where their craft is valued, not hidden behind content warnings.'
}, {
  icon: Users,
  title: 'Lost Connections',
  description: 'Finding collaborators who share your aesthetic vision means sifting through endless noise. Kindred spirits remain strangers.'
}];
export function ProblemsSection() {
  return <section id="problems" className="py-24 bg-obsidian relative" data-id="element-128">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
        <div className="text-center mb-16" data-id="element-130">
          <h2 className="font-heading text-3xl md:text-5xl text-parchment mb-4" data-id="element-131">
            The Void We Fill
          </h2>
          <div className="h-px w-20 bg-amber-glow/30 mx-auto" data-id="element-132" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-133">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="group relative bg-charcoal p-8 border border-white/5 hover:border-amber-glow/30 transition-all duration-500" data-id="element-134">
              {/* Candle Glow Effect on Hover */}
              <div className="absolute inset-0 bg-amber-glow/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-135" />
              <div className="absolute -inset-0.5 bg-gradient-to-b from-amber-glow/20 to-transparent opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-500" data-id="element-136" />

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-137">
                <div className="w-12 h-12 rounded-full bg-obsidian border border-amber-glow/20 flex items-center justify-center mb-6 text-amber-dim group-hover:text-amber-glow group-hover:border-amber-glow/50 transition-all duration-300" data-id="element-138">
                  <problem.icon className="w-6 h-6" data-id="element-139" />
                </div>

                <h3 className="font-heading text-xl font-bold text-parchment mb-4 group-hover:text-amber-glow transition-colors" data-id="element-140">
                  {problem.title}
                </h3>

                <p className="font-body text-lg text-bone/70 leading-relaxed" data-id="element-141">
                  {problem.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}